import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.jsx';
import { markExplicitMarketingHome } from '../../lib/dailyLanding.js';

const links = [
  { to: '/', label: 'Home', end: true },
  { to: '/today', label: "Today's Brief" },
  { to: '/archive', label: 'Archive' },
  { to: '/referrals', label: 'Referrals', authOnly: true },
];

function SearchIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20L16.5 16.5" />
    </svg>
  );
}

function linkClass({ isActive }) {
  return ['hxd-sub-nav-link', isActive ? 'active' : ''].filter(Boolean).join(' ');
}

export default function SubscriberSubNav() {
  const { isAuthenticated } = useAuth();
  const visible = links.filter((l) => !l.authOnly || isAuthenticated);

  return (
    <div className="hxd-sub-nav">
      <nav className="hxd-sub-nav-inner" aria-label="Subscriber sections">
        <div className="flex min-w-0">
          {visible.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={linkClass}
              onClick={l.to === '/' ? markExplicitMarketingHome : undefined}
            >
              {l.label}
            </NavLink>
          ))}
        </div>
        <NavLink
          to="/archive"
          className={({ isActive }) =>
            ['hxd-sub-nav-search', isActive ? 'active' : ''].filter(Boolean).join(' ')
          }
          aria-label="Search briefs"
          title="Search"
        >
          <SearchIcon />
        </NavLink>
      </nav>
    </div>
  );
}
